import {Content} from "#/src/pages/(auth)/login/Content";

export {Page}

function Page() {
  return <div className={"h-100"}><Content/></div>
}
